import { Theme, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles(({ spacing }: Theme) => ({
  select: {
    fontSize: 14,
    overflow: 'hidden',
    '& fieldset': {
      border: 'none',
    },
    '& div': {
      lineHeight: '16px',
    },
  },
  label: {
    fontSize: '12px',
    transform: 'translate(0, 8px) scale(0.857) !important',
  },
  labelWithoutValue: {
    transform: 'translate(0, 16px) scale(1) !important',
  },
  menuItem: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  menuItemLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  menuItemAction: {
    paddingRight: 0,
  },
  marginDense: {
    margin: `${spacing(0, 0)} !important`,
  },
}));
